import AddReview from './AddReview';
export default AddReview;
export type { AddReviewTypes } from './AddReview.types';

export const AddReview_Query = `
  _type == "AddReview" => {

  },
`;